import { Property } from '@/api/types/property';
import { PropertyModel } from '@/models/property';
import { transformServices } from './service';

export function transformProperty(property: Property) : PropertyModel {
  return {
    id: property.id,
    name: property.name,
    timezone: property.timezone,
    services: transformServices(property.services || []),
    isWhiteLabel: property.isWhiteLabel
  };
}

export function transformProperties(properties: Property[]): PropertyModel[] {
  return properties.map(transformProperty);
}
